<script setup lang="ts">
import { CartSharp, ChatbubbleEllipsesSharp, Close, CloseOutline, LogoWechat, Menu } from '@vicons/ionicons5'
import { addInpSearchRecord } from '@/service/api/basic'
import { local } from '@/utils'
import { setValue } from '@/utils/uCommonTs'

const contentShow = ref(false)

const userInfo = local.get('userInfo')

const successModal = ref(false)

const model = ref<any>({
  title: userInfo?.username,
  remark: '',
  niceClass: 0,
  position: false,
  planSource: '',
  searchKind: 10,
})
const defaultModel = JSON.parse(JSON.stringify(model.value))

const TypeDate = [
  { value: 0, label: '非常不满意' },
  { value: 1, label: '不满意' },
  { value: 2, label: '一般' },
  { value: 3, label: '满意' },
  { value: 4, label: '非常满意' },
]

const reasonsBad = [
  '页面加载慢',
  '页面信息布局乱',
  '产品功能不完善',
  '资源或功能难找',
  '操作指引不完善',
  '帮助信息太少',
]

const reasonsGood = [
  '页面信息与布局',
  '资源查找体验',
  '操作逻辑流畅',
  '页面加载速度',
  '产品功能拓展',
  '帮助信息增加',
]

const selectedReasons = ref([])

// 判断当前评分属于哪个分类
const isGoodRating = computed(() => model.value.niceClass > 3)
// 记录上一次的评分类型（是否为好评）
let lastIsGood = isGoodRating.value

// 当前显示的原因列表
const currentReasons = computed(() => {
  return isGoodRating.value ? reasonsGood : reasonsBad
})

// 监听评分变化
watch(
  () => model.value.niceClass,
  (newVal) => {
    const nowIsGood = newVal > 3
    // 只有当评分类型发生变化时才清空选择
    if (nowIsGood !== lastIsGood) {
      selectedReasons.value = []
    }

    // 更新记录
    lastIsGood = nowIsGood
  },
  { immediate: true },
)

function toggleReason(reason) {
  const index = selectedReasons.value.indexOf(reason)
  if (index > -1) {
    // 已选中，取消选中
    selectedReasons.value.splice(index, 1)
  }
  else if (selectedReasons.value.length < 3) {
    // 尚未选中且未达上限，添加
    selectedReasons.value.push(reason)
  }
  model.value.planSource = selectedReasons.value.join(',')
}

async function handleValidateClick() {
  const res = await addInpSearchRecord(model.value)
  if (res.code === 1000) {
    // window.$message.success('感谢您的反馈，我们会尽快处理！')
    Object.assign(model.value, defaultModel)
    selectedReasons.value = []
    contentShow.value = false
    successModal.value = true
    local.set('activeShowRemark', '1')
  }
}

onMounted(() => {
  const activeShowRemark = local.get('activeShowRemark')
  const loginShowRemark = local.get('loginShowRemark')
  // 用户评价过了就不再主动弹出
  if (activeShowRemark === '1')
    return
  // 单次登录，如果弹过了，则本次登录就不再主动弹出了，下次登录在弹出，所以退出登录需要清掉loginShowRemark
  if (loginShowRemark === '0' || !loginShowRemark) {
    setTimeout(() => {
      contentShow.value = true
      local.set('loginShowRemark', '1')
    }, 60000 * 5)
  }
})
</script>

<template>
  <div class="fixed right-20px bottom-[30%] z-10 translate-y-1/2">
    <n-float-button-group position="relative">
      <n-float-button shape="square" @click="$router.push('/searchTools/cart')">
        <n-icon size="25">
          <CartSharp />
        </n-icon>
      </n-float-button>
      <n-tooltip trigger="hover" placement="right">
        <template #trigger>
          <router-link v-track="{ type: 'Page_Jumpto', data: '点击联系客服', public: true }" class="block" to="/accountCenter/contact">
            <n-float-button position="relative" shape="square">
              <n-icon>
                <ChatbubbleEllipsesSharp />
              </n-icon>
            </n-float-button>
          </router-link>
        </template>
        点击联系客服
      </n-tooltip>
      <n-popover style="width: 240px;border-radius: 8px;padding: 20px 0;left: -15px;" placement="left" trigger="hover">
        <template #trigger>
          <div class="flex flex-col items-center">
            <n-float-button position="relative" shape="square">
              <n-icon>
                <LogoWechat />
              </n-icon>
            </n-float-button>
          </div>
        </template>
        <div class="flex-center flex-col">
          <p class="mb-2 text-center">
            扫码关注官方公众号 <br>
            获取最新出海资讯
          </p>
          <img src="@/assets/images/qrcode/gzh.svg" alt="gzh">
        </div>
      </n-popover>
      <n-popover class="overflow-auto lt-2xl:max-h-500px lt-xl:max-h-450px" style="width: 450px;border-radius: 8px;left: -15px;padding: 0;" :show="contentShow" placement="left-end" trigger="click" :show-arrow="false" @update:show="contentShow = !contentShow;model.niceClass = 0">
        <template #trigger>
          <div class="flex flex-col items-center">
            <n-float-button position="relative" shape="square">
              <svg-icons-opinion class="svg-options" />
            </n-float-button>
          </div>
        </template>
        <div class="">
          <div class="p-16px bg-#1664FF relative">
            <h4 class="text-18px text-center font-bold text-#fff ">
              意见反馈
            </h4>
            <n-icon size="20" color="#fff" class="cursor-pointer absolute right-20px top-50% transform-translate-y-[-50%]" @click="contentShow = false;model.niceClass = 0">
              <Close />
            </n-icon>
          </div>
          <div class="p-16px">
            <div class="mb-20px">
              <div class="mb-16px">
                您对当前新版会员中心的整体使用感受是否满意？
              </div>
              <div class="text-center">
                <n-rate v-model:value="model.niceClass" class="flex justify-between">
                  <template #default="{ index }">
                    <div class="">
                      <i class="n-base-icon"><svg viewBox="0 0 512 512"><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z" /></svg></i>
                      <div class="text-14px">
                        {{ setValue(TypeDate, index, 'label') }}
                      </div>
                    </div>
                  </template>
                </n-rate>
              </div>
            </div>
            <template v-if="model.niceClass > 0">
              <div class="mb-20px">
                <div class="mb-16px">
                  {{ model.niceClass > 3 ? '您会期望看到哪些调整或改进？（最多选3项）' : '您感到不满意的原因是？（最多选3项）' }}
                </div>
                <div class="reason-grid">
                  <div
                    v-for="(reason, index) in currentReasons"
                    :key="index"
                    class="reason-item"
                    :class="{ active: selectedReasons.includes(reason) }"
                    @click="toggleReason(reason)"
                  >
                    {{ reason }}
                  </div>
                </div>
              </div>
              <div class="mb-10px">
                <div class="mb-16px">
                  您对新版会员中心还有哪些需求与建议，或者问题反馈？
                </div>
                <n-form-item path="remark" :show-label="false">
                  <n-input
                    v-model:value="model.remark"
                    placeholder="请描述您的具体问题、需求场景与改进建议（选填）"
                    type="textarea"
                    rows="5"
                  />
                </n-form-item>
              </div>
            </template>
            <div class="flex items-center justify-between">
              <n-checkbox v-model:checked="model.position" checked-value="是" unchecked-value="否">
                我同意接受回访，请联系我预约时间
              </n-checkbox>
              <n-button v-track="{ data: '意见反馈提交', public: true }" type="info" color="#1664FF" size="large" :disabled="model.niceClass === 0 || selectedReasons.length === 0" @click="handleValidateClick">
                提交
              </n-button>
            </div>
          </div>
        </div>
      </n-popover>
    </n-float-button-group>
  </div>
  <n-modal v-model:show="successModal" :mask-closable="false" preset="dialog" title="意见反馈" :show-icon="false" class="max-w-450px">
    <!-- <template #header>
      <div>标题</div>
    </template> -->
    <div class="py-10px">
      <n-result class="mb-12px" status="success" size="small" />
      <div class="text-center line-height-[2]">
        <p class="text-18px">
          感谢您的反馈！
        </p>
        <p>我们将尽快响应，为您提供更好的服务与体验</p>
      </div>
    </div>
  </n-modal>
</template>

<style lang="scss" scoped>
  :deep(.n-rate){
    .n-rate__item{
      flex: 1;
      justify-content: center;
    }
  }
  .reason-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 12px;
  }

  .reason-item {
    padding: 12px;
    border: 1px solid #e4e4e4;
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #f9f9f9;
    color: #666;
  }

  .reason-item.active {
    background-color: #1664FF;
    color: white;
    border-color: #1664FF;
  }

  .n-float-button:hover, .n-float-button:active {
    // box-shadow: 0 2px 12px 0px #1664FF;
    background: #1664FF;
    .n-icon {
      color: #fff;
    }
    ::v-deep(.svg-options path){
      fill: #fff;
    }
  }
</style>
